import { GoogleLogin } from "@react-oauth/google";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/auth.css";

export default function Login({ setUser }) {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const handleLogin = async (e) => {

    e.preventDefault();

    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    });

    const data = await res.json();

    if (data.success) {

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      setUser(data.user);

      // 🔐 Secure role-based redirect
      if (data.user.role === "employee") {
        navigate("/employee-dashboard");
      } else {
        navigate("/dashboard");
      }

    } else {

      if (data.error?.toLowerCase().includes("not found")) {
        alert("User not found. Kindly sign up first.");
        navigate("/register");
      }

      else if (data.error?.toLowerCase().includes("password")) {
        alert("Incorrect password. Please try again.");
      }

      else {
        alert(data.error || "Login failed");
      }
    }
  };

  const googleSuccess = async (res) => {

    const r = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/google`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ token: res.credential })
    });

    const data = await r.json();

    if (data.success) {

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      setUser(data.user);

      // 🔐 Secure role-based redirect
      if (data.user.role === "employee") {
        navigate("/employee-dashboard");
      } else {
        navigate("/dashboard");
      }

    } else {
      alert("Google login failed");
    }
  };

  return (

    <div className="auth-page">

      <div className="auth-box">

        <h2>Welcome back</h2>
        <p className="auth-desc">Login to manage your account</p>

        <form onSubmit={handleLogin}>

          <input
            type="email"
            placeholder="Email address"
            value={form.email}
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={(e) =>
              setForm({ ...form, password: e.target.value })
            }
            required
          />

          <button type="submit">Login</button>

        </form>

        <div className="auth-divider">
          <span>OR</span>
        </div>

        <div className="google-btn-wrapper">
          <GoogleLogin onSuccess={googleSuccess} />
        </div>

        <div className="auth-footer">
          Don’t have an account?
          <span onClick={() => navigate("/register")}> Register</span>
        </div>

      </div>

    </div>
  );
}